<span #textElement nz-tooltip [nzTooltipOverlayClassName]="'tooltip'" [nzTooltipTitle]="isEllipsisActive ? value : null">
  {{ value | lT }}
</span>
